import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../_services/authentication.service';
import { UserService } from '../_services/user.service';
import { OrganizationService } from '../_services/organization.service';
import { RoleService } from '../_services/role.service';

import { Organization } from '../_models/organization';
import { Role } from '../_models/role';
import { User } from '../_models/user';

@Component({
  moduleId: module.id,
  templateUrl: 'users.component.html',
  styleUrls: ['users.component.css']
})

export class UsersComponent implements OnInit {
  users: Array<User>;
  organizations: Array<Organization>;
  roles: Array<Role>;
  selectedOrg: Number;
  selectedOrgName: string = 'Filter by Organization';
  resetPasswordSent: boolean = false;
  error: boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private organizationService: OrganizationService,
    private roleService: RoleService,
  ){}

  ngOnInit() {
    Promise.all<Organization[], User[], Role[]>([this.organizationService.getAll(), this.userService.getAll(), this.roleService.getAll()])
      .then(([orgs, users, roles]) => {
        this.organizations = orgs;
        this.roles = roles;
        this.users = users.filter(u => u.disabled === '0').map(u => {
          u.organization = orgs.filter(o => o.id === u.organization_id)[0].name;
          u.role = roles.filter(r => r.id === u.role_id)[0].name;
          return u;
        });
      });
  }

  filterByOrg(event: Event, id: number, name: string): void {
    event.preventDefault();
    this.selectedOrg = id;
    this.selectedOrgName = name;
  }

  onError(err) {
    this.resetPasswordSent = false;
    this.error = true;
  }

  sendPasswordReset(username: string) {

    this.userService.sendPasswordReset(username)
      .then(data => {
        this.resetPasswordSent = true;
      }, this.onError)
      .catch(this.onError.bind(this));
  }

}



// WEBPACK FOOTER //
// ./src/app/users/users.component.ts